import React from "react";
import { RefreshCw } from "lucide-react";
import { SegmentedControl } from "./AnalyticsUI";

export const PRESETS = [
  { value: "today", label: "Today", days: 1 },
  { value: "7d", label: "7 Days", days: 7 },
  { value: "30d", label: "30 Days", days: 30 },
  { value: "90d", label: "90 Days", days: 90 },
  { value: "custom", label: "Custom" },
];

const lastUpdatedFmt = new Intl.DateTimeFormat("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

const AnalyticsFilters = ({
  preset,
  onPresetChange,
  range,
  onCustomRangeChange,
  stationId,
  onStationChange,
  stationOptions,
  groupId,
  onGroupChange,
  groupOptions,
  onRefresh,
  isRefreshing,
}) => (
  <div className="card flex flex-col gap-4 p-4 xl:flex-row xl:items-end">
    <div className="flex flex-col gap-1.5">
      <span className="field-label">Period</span>
      <div className="flex flex-wrap items-center gap-2">
        <SegmentedControl options={PRESETS} value={preset} onChange={onPresetChange} size="md" />
        {preset === "custom" && (
          <div className="flex items-center gap-2">
            <input
              type="date"
              value={range.fromDate}
              max={range.toDate}
              onChange={(e) => e.target.value && onCustomRangeChange({ ...range, fromDate: e.target.value })}
              className="input w-[150px]"
              aria-label="From date"
            />
            <span className="text-13 text-muted">to</span>
            <input
              type="date"
              value={range.toDate}
              min={range.fromDate}
              onChange={(e) => e.target.value && onCustomRangeChange({ ...range, toDate: e.target.value })}
              className="input w-[150px]"
              aria-label="To date"
            />
          </div>
        )}
      </div>
    </div>

    <div className="flex flex-wrap items-end gap-3 xl:ml-auto">
      <label className="flex flex-col gap-1.5">
        <span className="field-label">Station</span>
        <select value={stationId} onChange={(e) => onStationChange(e.target.value)} className="input min-w-[200px] pr-8">
          <option value="">All stations</option>
          {stationOptions.map((s) => (
            <option key={s.value} value={s.value}>{s.label}</option>
          ))}
        </select>
      </label>

      {groupOptions.length > 1 && (
        <label className="flex flex-col gap-1.5">
          <span className="field-label">Group</span>
          <select value={groupId} onChange={(e) => onGroupChange(e.target.value)} className="input min-w-[140px] pr-8">
            <option value="">All groups</option>
            {groupOptions.map((g) => (
              <option key={g} value={g}>Group {g}</option>
            ))}
          </select>
        </label>
      )}

      <button type="button" onClick={onRefresh} disabled={isRefreshing} className="btn-secondary">
        <RefreshCw className={`h-3.5 w-3.5 ${isRefreshing ? "animate-spin" : ""}`} />
        Refresh
      </button>
    </div>
  </div>
);

export const LastUpdated = ({ lastUpdated }) => (
  <span className="text-xs text-muted">
    {lastUpdated ? `Last updated ${lastUpdatedFmt.format(lastUpdated)}` : "Loading…"}
  </span>
);

export default AnalyticsFilters;
